import { Box, Typography, TypographyOwnProps } from "@mui/material";
import { keyframes } from "@mui/system";
import { zeroPad } from "components/util/pad";

import { TimeKeeperProps, useTimeKeeper } from "components/routes/events/useTimeKeeper";

const warningAnimationStyles = {
    animation: `${keyframes`
        0% {
            opacity: 1;
        }

        50% {
            opacity: 0.3;
        }

        100% {
            opacity: 1;
        }
    `} 2s infinite`,
};

export type TimerSize = "xs" | "sm" | "md" | "lg" | "xl" | "xxl";

const sizeToVariant: Record<TimerSize, TypographyOwnProps["variant"]> = {
    xs: "monoTimerXs",
    sm: "monoTimerSm",
    md: "monoTimerMd",
    lg: "monoTimerLg",
    xl: "monoTimerXl",
    xxl: "monoTimerXxl",
};

type TimerProps = TimeKeeperProps & { size?: TimerSize };

export const Timer = ({
    start,
    duration,
    remainingMillisecondsOnPause,
    resume,
    size = "xxl",
}: TimerProps) => {
    const remainingTime = useTimeKeeper({ start, duration, remainingMillisecondsOnPause, resume });
    const pad = (num: number) => zeroPad(num.toString());
    const remainingMinutes = remainingTime.hours() * 60 + remainingTime.minutes();
    const hasWarningAnimation = remainingTime.asMilliseconds() <= 5 * 60000 && duration >= 10;

    return (
        <Box
            className="timer-wrapper"
            sx={hasWarningAnimation ? warningAnimationStyles : undefined}
        >
            <Typography data-testid="display-time" variant={sizeToVariant[size]}>
                {`${pad(remainingMinutes)}:${pad(remainingTime.seconds())}`}
            </Typography>
        </Box>
    );
};
